import { render, staticRenderFns } from "./CategoryCard2.vue?vue&type=template&id=fa858eb4&scoped=true&"
import script from "./CategoryCard2.vue?vue&type=script&lang=js&"
export * from "./CategoryCard2.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCard2.vue?vue&type=style&index=0&id=fa858eb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa858eb4",
  null
  
)

export default component.exports